<template>
  <div class="event-times">
    <div v-for="(time, i) in times" :key="i" class="event-time mb-3">
      <div v-if="times.length > 1" class="day-tag">Day {{ i + 1 }}</div>
      <TimeField
        label="Start Time"
        :name="`times[${i}][start_time]`"
        :value="time.start_time"
      />
      <div class="separator">/</div>
      <TimeField
        label="End Time"
        :name="`times[${i}][end_time]`"
        :value="time.end_time"
      />
      <input type="hidden" :name="`times[${i}][order]`" :value="i + 1" />
      <a
        v-if="i > 0"
        class="btn btn-sm btn-danger ml-3"
        href="#"
        @click.prevent="remove(i)"
        >Remove</a
      >
    </div>
    <a class="btn btn-sm btn-info" href="#" @click.prevent="add()"
      >Add Another Day</a
    >
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      times: [],
    };
  },
  watch: {
    value(val) {
      this.times = val;
    },
    times(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    add() {
      this.times.push({
        start_time: "08:00",
        end_time: "12:00",
      });
    },
    remove(index) {
      let times = this.times;
      this.times = [];
      this.times = times.filter((t, i) => i != index);
    },
  },
  created() {
    this.times = this.value;
    if (this.times.length == 0) {
      this.add();
    }
  },
};
</script>